export default class TA_API {
  static storage = {
    transferAgent: {
      properties: {
        // Holds the amount of launches the user has initiated
        launches: "manualTALaunches",
        // Holds the amount of downloads the user has initiated
        downloads: "manualTADownloads",
      },
      /**
       * Get or set the amount of launches the user has initiated.
       *
       * @param  attempts {number} The new amount of launches that were initiated.
       * @return          {number} The current amount of launches that were initiated. If attempts parameter is
       *                           provided, it will return that number.
       */
      launches: function (attempts) {
        return TA_API.storage.transferAgent.persist(
          TA_API.storage.transferAgent.properties.launches,
          attempts
        );
      },
      /**
       * Get or set the amount of downloads the user has initiated.
       *
       * @param  attempts {number} The new amount of downloads that were initiated.
       * @return          {number} The current amount of downloads that were initiated. If attempts parameter is
       *                           provided, it will return that number.
       */
      downloads: function (attempts) {
        return TA_API.storage.transferAgent.persist(
          TA_API.storage.transferAgent.properties.downloads,
          attempts
        );
      },
      /**
       * Get or set a number persistence property.
       *
       * @param  property {string} The name of the persistence property to modify/retrieve.
       * @param  value    {number} The new value of the persistence property.
       * @return          {number} The current value of the persistence property. If the value parameter is
       *                           provided, it will return that number.
       */
      persist: function (property, value) {
        var currentValue;

        if (value !== undefined) {
          window.localStorage.setItem(property, value);
        }

        currentValue = window.localStorage.getItem(property);

        if (currentValue !== null) {
          currentValue = parseInt(currentValue);
        }

        return currentValue;
      },
      /**
       * Forget amount of launches and downloads for TA by the user.
       */
      reset: function () {
        window.localStorage.removeItem(
          TA_API.storage.transferAgent.properties.launches
        );
        window.localStorage.removeItem(
          TA_API.storage.transferAgent.properties.downloads
        );
      },
    },
  };
}
